import React from "react";

import "./Icon.scss";

export type NewIconProps = {
  cx?: string;
  onClick: () => void;
};

export const NewIcon: React.FC<NewIconProps> = ({ cx = "", onClick }) => {
  return (
    <svg
      width="70"
      height="70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`NewIcon ${cx}`}
      onClick={onClick}
    >
      <rect width="70" height="70" rx="30" className={"rect-1"} />
      <rect x="1" y="1" width="68" height="68" rx="29" className={"rect-2"} />
      <path
        d="M23.321 35.086h23.357M35.079 46.68V23.323"
        className={"rect-3"}
      />
    </svg>
  );
};
